import CreateProjectTypeContainer from "./CreateProjectTypeContainer";
export default CreateProjectTypeContainer;
